module.exports = __webpack_public_path__ + "static/media/resetWarning.01a81963.svg";